import { useMutation, useQueryClient, UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { deleteRuleOverrides } from 'Services';
import { RQ_TENANT_OVERRIDES, RQ_GLOBAL_RULES, RQ_MERCHANT_RULES } from 'Utils';
import useTenantErrorHandler from './useTenantErrorHandler';

type MutationOptions = UseMutationOptions<AxiosResponse<any>, unknown, string, unknown>;

type Arguments = {
    mutationOptions: MutationOptions;
    ruleId: string;
};

const deleteOverride = () => (ruleId: string) => {
    return deleteRuleOverrides(ruleId);
};

function useDeleteTenantOverride({ ruleId, mutationOptions: { onSuccess, onError } }: Arguments) {
    const queryClient = useQueryClient();
    const errorHandler = useTenantErrorHandler({
        mutationOptions: {
            onError
        },
        mode: 'deleteTenantOverride',
        ruleId,
        queryInvalidateFunction: () => {
            queryClient.invalidateQueries([RQ_TENANT_OVERRIDES]);
            queryClient.invalidateQueries([RQ_GLOBAL_RULES]);
        }
    });

    return useMutation(deleteOverride(), {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries([RQ_TENANT_OVERRIDES]);
            queryClient.invalidateQueries([RQ_GLOBAL_RULES]);
            queryClient.invalidateQueries([RQ_MERCHANT_RULES]);
            onSuccess?.(data, variables, context);
        },
        onError: errorHandler
    });
}

export default useDeleteTenantOverride;
